import React from "react";
import {DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import Dialog from "../../../components/base/dialog";
import Button from "../../../components/base/button/button";
import PartFormQualificationErrorIndicator from "./part-form-qualification-error-indicator";

const PartFormQualificationFetchErrorDialog = ({
    open,
    onClose,
    onRetry,
    loading = false,
    errorMessage,
    customerId,
    showCustomerProfileButton = false,
}) => {
    const {t} = useTranslation("dialogs", {keyPrefix: "partFormQualificationFetchErrorDialog"});

    return (
        <Dialog
            open={open}
            setOpen={(v) => !v && onClose()}
            maxWidth="sm"
            fullWidth
            scroll="paper"
            className="bound-dialog part-form-qualification-fetch-error-dialog"
            loading={loading}
        >
            <DialogTitle fontWeight={600} component="div">
                <Typography variant="h6" fontWeight={600} sx={{padding: 2}}>
                    {t("title")}
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <PartFormQualificationErrorIndicator
                    onRetry={onRetry}
                    errorMessage={errorMessage}
                    customerId={customerId}
                    showCustomerProfileButton={showCustomerProfileButton}
                />
            </DialogContent>
            <DialogActions sx={{display: "flex", justifyContent: "space-between"}}>
                <Button variant="dialog" color="primary" onClick={onClose} borderRadius="0 8px 0 0">
                    {t("close")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PartFormQualificationFetchErrorDialog;
